import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "space-y-1" }
const _hoisted_2 = { class: "flex font-bold" }

import { useFactionsStore } from '@/store/factions';
import { FactionScorecard } from '@/typings/faction';
import { toRefs } from 'vue';
import { useRouter } from 'vue-router';
import User from '../User/User.vue';

interface Props {
  card: FactionScorecard;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    card: null
  },
  setup(__props: any) {

const props = __props as {
  card: FactionScorecard;
}



const { card } = toRefs(props);

const store = useFactionsStore();

const router = useRouter();

function open() {
  if (store.faction && card.value) {
    router.push({
      name: 'FactionScorecard',
      params: {
        factionId: store.faction.Uuid,
        slug: card.value.Slug,
      },
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "w-48 p-2 mb-4 font-bold text-white uppercase truncate cursor-pointer bg-primary",
      onClick: open
    }, _toDisplayString(_unref(card).Title), 1),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(card).Rankings, (rank) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${_unref(card).Title}_${rank.User.Uuid}`,
          class: "flex justify-between px-3"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(User, {
              user: rank.User,
              "hide-tags": ""
            }, null, 8, ["user"])
          ]),
          _createTextVNode(" " + _toDisplayString(rank.Score), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})